<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";

import Stat from "@/components/stat";
import OrdersList from "@/components/orderslist"
// import TopItems from "@/components/topItems";
// import QuantityVolume from "../reporting/quantityPerTraderAndBrand.vue";

import {Priviliges} from "../../../privileges";

import OrdersApi from "@/services/orders-api";
import InvoicesApi from "@/services/invoices-api";
import ReportingApi from "@/services/reporting-api";

import Highlights from "@/components/highlights";
import {Dimensions} from "../banner-news/bannerDimensions";
import BannerApi from "@/services/banner-api";

import i18n from "@/i18n";

/**
 * Supplier Home component
 */
export default {
  page: {
    title: "Tableau de Bord",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout,Stat,OrdersList,/*TopItems,QuantityVolume*/ Highlights},

  mounted(){
      
      this.findBanner();

      var date = new Date();
      this.firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      const startoffset = this.firstDay.getTimezoneOffset()
      this.firstDay= new Date(this.firstDay.getTime() - (startoffset*60*1000))
      this.firstDay=this.firstDay.toISOString().split('T')[0]

      this.lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
      const endoffset = this.lastDay.getTimezoneOffset()
      this.lastDay= new Date(this.lastDay.getTime() - (endoffset*60*1000))
      this.lastDay=this.lastDay.toISOString().split('T')[0]
    if(sessionStorage.getItem("privileges")!=null){
      this.privileges=sessionStorage.getItem("privileges")
      this.isAdmin=this.privileges.includes(Priviliges[0]["Admin_Role"] )
      this.hasOrdersListAccess= this.privileges.includes(Priviliges[0]["OrderList_Access"] )
      this.hasReportingAccess=this.privileges.includes(Priviliges[0]["Sales_Statistics_Access"] )
      this.hasInvoicesAccess = this.privileges.includes(Priviliges[0]["InvoicesList_Access"])
      this.hasSynchronisationAccess=this.privileges.includes(Priviliges[0]["Synchronization_Reports_Access"] )
    }
    if(this.isAdmin || this.hasReportingAccess){
      this.getTotalTurnover();
    }

    if(this.isAdmin || this.hasInvoicesAccess){
      this.getUnpaidInvoicesCount()
    }

    if(this.isAdmin || this.hasOrdersListAccess){
      this.getNewOrdersCount()
      // this.getConfirmedOrdersCount()
    }

    if(this.isAdmin || this.hasSynchronisationAccess){
      this.getLastSynchronisationAccess()
    }


  },

  computed:{
    statData(){
      return [
            {
            index:1,
            icon: "fas fa-dolly",
            title:i18n.t('supplierHome.stat.1.title'), //"Commandes"
            value1: this.newOrdersCount,
            text1:i18n.t('supplierHome.stat.1.text1') ,//"Nouvelles",
            // value2: "0",
            // text2:"Confirmées",
            bg: "bg-primary",
            },
            // {
            // index:2,
            // icon: "fas fa-file-invoice-dollar",
            // title: i18n.t('supplierHome.stat.2.title'),//  "Factures",
            // value1: this.unpaidInvoicesCount,
            // text1:i18n.t('supplierHome.stat.2.text1'), //"Impayées",
            // bg: "bg-primary"
            // },
            // {
            // index:3,
            // icon: "fas fa-dollar-sign",
            // title:i18n.t('supplierHome.stat.3.title'),// "C.A Annuel ",
            // value1: this.turnover,
            // text1:i18n.t('supplierHome.stat.3.text1'), //"(HT)",
            // bg: "bg-primary"
            // },
            {
            index:4,
            icon: "fa fa-check",
            title: i18n.t('supplierHome.stat.4.title'),//"Sync avec Sage",
            value1: this.syncDate,
            text1:i18n.t('supplierHome.stat.4.text1'), //"Date Derniére Sync",
            bg:"bg-primary"
            },
        ]
    }
  },

  data() {
    return {
        privileges:"",
        isAdmin:false,
        hasOrdersListAccess:false,
        hasReportingAccess:false,
        firstDay:"",
        lastDay:"",
        newOrdersCount:"0",
        unpaidInvoicesCount:"0",
        turnover:"0",
        syncDate:"",

        isBannerTableBusy:false,
        bannerList: [],
        dimensions : Dimensions,
      };
  },

  methods: {

    getNewOrdersCount(){
      OrdersApi.getOrdersCount(1)
      .then((result) => {
        if (result != null) {
          this.newOrdersCount=result.toString();
        }
      })
    },
    getConfirmedOrdersCount(){
      OrdersApi.getOrdersCount(2)
      .then((result) => {
        if (result != null) {
          this.statData[0].value2 = result.toString();
        }
      })
    },
    getUnpaidInvoicesCount(){
      InvoicesApi.getInvoicesCount(0)
      .then((result) => {
        if (result != null) {
          this.unpaidInvoicesCount=result.toString();
        }
      })
    },
    getTotalTurnover(){
        ReportingApi.getTotalTurnover(null,null,false,true).then(
            (result)=>{
                this.turnover=result.selectedPeriodValueAsString ===null ? "0" : result.selectedPeriodValueAsString 
            }
        )
    },

    getLastSynchronisationAccess(){
      ReportingApi.getLastSynchronisationAccess().then(
        (result)=>{
          this.syncDate=result
        }
      )
    },

    findBanner() {
      this.isBannerTableBusy = true;
      BannerApi.getActiveBanners()
        .then((result) => {
          this.bannerList = result;
        })
        .finally(() => {
          this.isBannerTableBusy = false;
        });
    },

  },

};
</script>

<template>
  <Layout>

    <!-- ADS Banner SECTION -->
    <div class="row" >
      <div class="col-12 d-none d-sm-block">
          <b-carousel
                style="text-shadow: 0px 0px 2px #000"
                :img-width="dimensions[0]['width']"
                :img-height="dimensions[0]['height']"
                :interval="4000"
                indicators
                controls
              >

                <b-carousel-slide :caption="$t('customerHomePage.banners.caption')"  img-blank img-alt="Blank Image " v-if="isBannerTableBusy || !bannerList || !bannerList.length">
                  <p class="text-primary">
                    {{$t('customerHomePage.banners.empty')}}
                  </p>
                </b-carousel-slide> 

                <div v-for="banner in bannerList" :key="banner.id" >
                  <b-carousel-slide v-if="!isBannerTableBusy"
                    :img-src="'/api/banner/get/' + banner.generatedName" style="height:100%;width:100%; opacity:1;"
                  ></b-carousel-slide>
                </div>
          </b-carousel>
      </div>
    </div>

    
    

    <!-- END OF ADS Banner SECTION -->

    <div class="row pl-4 pt-4">

        <div class="col-12">
          <Highlights />
        </div>

    </div>

    <div class="row mt-3 mr-md-4 ml-md-4" >
      <div v-for="stat of statData" :key="stat.index" class="col-xl-6 col-lg-6 col-md-6 col-sm-6 pt-4 pl-4 pr-4" >
        <Stat :icon="stat.icon" :title="stat.title" :value1="stat.value1" :text1="stat.text1"  :value2="stat.value2" :text2="stat.text2"  :bg="stat.bg"/>
      </div>
    </div>

    <div class="row mb-4 mt-2 mr-md-4 ml-md-4">
        <div v-if="isAdmin || hasOrdersListAccess" class="pr-3 pl-3 pt-4" :class="isAdmin || hasReportingAccess ? 'col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12' : 'col-12'">
            <div class="card m-2 h-100  border border-primary">
                <div class="card-body p-0 ">
                    <div class="clearfix m-4">
                      <h4 class="card-title font-size-18 pb-2 text-warning">{{$t('customerHomePage.orders.title')}} </h4>
                      <OrdersList  :isHomePage=true :isCurrent=true />
                    </div>
                </div>
            </div>
        </div>
        <!-- <div  v-if="isAdmin || hasOrdersListAccess" class="pr-3 pl-3 pt-4" :class="isAdmin || hasOrdersListAccess ? 'col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12' : 'col-12'">
          <div class="card m-2 h-100 border border-warning">
              <div class="card-body p-0 ">
                  <QuantityVolume :firstDay=this.firstDay :lastDay=this.lastDay  />
              </div>
          </div>
        </div> -->
    </div>
    <!-- <div class="row mb-4 mt-2 mr-md-4 ml-md-4">
        <div  v-if="isAdmin || hasReportingAccess" class="pr-3 pl-3 pt-4 col-12" >
          <div class="card m-2 h-100 border border-warning">
              <div class="card-body p-0 ">
                  <TopItems :isReportingPage=true :isHomePage=true :firstDay=this.firstDay :lastDay=this.lastDay  />
              </div>
          </div>
        </div>
    </div> -->
  </Layout>
</template>
